import { render, staticRenderFns } from "./KeywordCategoryEditForm.vue?vue&type=template&id=5914e2a0"
import script from "./KeywordCategoryEditForm.vue?vue&type=script&lang=js"
export * from "./KeywordCategoryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports